module.exports = __webpack_public_path__ + "img/耐高温管理标签.d57dabb2.jpg";